import type { ChatRequestPayload, MemoryCandidate } from "../types/app";
import { normalizeApiError } from "../services/apiErrors";

export async function streamChat(
  payload: ChatRequestPayload,
  onDelta: (text: string) => void,
  signal?: AbortSignal,
): Promise<{ text: string; memoryCandidates: MemoryCandidate[] }> {
  const response = await fetch("/api/chat", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal,
  });
  if (!response.ok) {
    let body: unknown;
    try {
      body = await response.json();
    } catch {
      body = await response.text().catch(() => "");
    }
    throw normalizeApiError(response.status, body);
  }
  if (!response.body) return { text: "", memoryCandidates: [] };
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let text = "";
  let memoryCandidates: MemoryCandidate[] = [];
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() ?? "";
    for (const line of lines) {
      if (!line.trim()) continue;
      const event = JSON.parse(line) as {
        type: string;
        delta?: string;
        candidates?: MemoryCandidate[];
        code?: string;
        message?: string;
      };
      if (event.type === "error") {
        throw new Error(event.message || "AIから返答文を取得できませんでした。");
      }
      if (event.type === "delta" && event.delta) {
        text += event.delta;
        onDelta(event.delta);
      }
      if (event.type === "memory_candidates") memoryCandidates = event.candidates ?? [];
    }
  }
  return { text, memoryCandidates };
}
